<template>
    <UiPageTitle class="sb-page-title" data-test="sb-page-title" :blok="blok" />
</template>

<script setup lang="ts">
import type { IPageTitle } from '@nuxt-monorepo/ui/types/components/PageTitle';

defineProps<{ blok: IPageTitle }>();
</script>

<style scoped lang="postcss">
.sb-page-title {
    @apply relative pb-3 md:pb-5;
    :deep(.page-title-inner) {
        @apply text-[63%] md:text-[75%] lg:text-[100%];
    }
    &:before,
    &:after {
        content: '';
        @apply absolute left-1/2 bottom-0 bg-primary -translate-x-1/2;
    }
    &:before {
        @apply w-9 h-[3px] -bottom-[1px];
    }
    &:after {
        @apply w-[164px] h-[1px];
    }
}
</style>
